export default "__VITE_ASSET__CEpxBD55__"